
import Vue from "vue";


export default Vue.extend( {
  name: "PdfThumbnail",
  props: {
    url: {
      type: String,
      required: true,
    },
    mimeType: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 200,
    },
    height: {
      type: Number,
      default: 200,
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      canvas: null,
    }
  },
  mounted() {
    this.renderThumbnails();
  },
  methods: {
    async renderThumbnails() {
      const canvasWidth = this.width;
      const canvasId = this.id;
      if( this.mimeType.indexOf("pdf") > -1 ) {
        import("pdfjs-dist/build/pdf.min").then((pdfjsLib) => {
          pdfjsLib.GlobalWorkerOptions.workerSrc =
              "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.7.107/build/pdf.worker.min.js";

          const worker = new pdfjsLib.PDFWorker();

          pdfjsLib
              .getDocument({url: this.url, worker: worker})
              .promise.then((pdf: any) => {

            pdf.getPage(1).then(function(page: any) {
              let c = document.getElementById(canvasId);
              if (c) {
                let canvas = (c as any).getContext('2d');
                let viewport = page.getViewport({scale: 1});
                viewport = page.getViewport({scale: canvasWidth / viewport.width});
                page.render({canvasContext: (canvas), viewport: viewport});
              }
            });

          });
        });
      }
    },
  },
});
